import React, { useContext } from "react";

import { EventContext, SportOfferContext } from "@gp/components";
import { EventOffer, SportOffer } from "@gp/offer";
import { useFormatTennisGameScore } from "@hooks";
import { useOfferColumnResult } from "@state/hooks/offer/useOfferColumnResult";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import classnames from "classnames";
import { observer } from "mobx-react";

export const OfferColumnResult = observer(function OfferColumnResult() {
	// @ts-expect-error
	const event: EventOffer = useContext(EventContext);
	// @ts-expect-error
	const sport: SportOffer = useContext(SportOfferContext);
	const { serve, currentScore, lastPeriodScore, isRounded } =
		useOfferColumnResult(event, sport);

	const gameScore = useFormatTennisGameScore(event, sport);

	if (lastPeriodScore == null) {
		return <td className="match__score">&nbsp;</td>;
	}

	return (
		<div className="match__score">
			<div className="match__score__wrapper">
				<div
					className={classnames("match__score__server", {
						"is-empty": serve == null,
					})}
				>
					<div>
						{serve === "home" ? (
							<div className="match__score__serve" />
						) : null}
					</div>
					<div>
						{serve === "away" ? (
							<div className="match__score__serve" />
						) : null}
					</div>
				</div>
				{gameScore != null ? (
					<div
						className={classnames("match__score__game", {
							"is-rounded": isRounded,
						})}
					>
						<div>{gameScore.home || 0}</div>
						<div>{gameScore.away || 0}</div>
					</div>
				) : null}

				<div className="match__score__set">
					<div>{lastPeriodScore.home || 0}</div>
					<div>{lastPeriodScore.away || 0}</div>
				</div>
				<div className="match__score__match">
					<div>{currentScore?.home || 0}</div>
					<div>{currentScore?.away || 0}</div>
				</div>
			</div>
		</div>
	);
});
